import { render, staticRenderFns } from "./DocumentIssuers.vue?vue&type=template&id=54ddd516&scoped=true"
import script from "./DocumentIssuers.vue?vue&type=script&lang=js"
export * from "./DocumentIssuers.vue?vue&type=script&lang=js"
import style0 from "./DocumentIssuers.vue?vue&type=style&index=0&id=54ddd516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ddd516",
  null
  
)

export default component.exports